// ContactForm.js
import React, { useState } from 'react';
import '../styles/contactus.css'; // Import your styles
import contactUsImage from '../assets/contact-header.jpg'; // Image asset

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    message: ''
  });

  const [responseMessage, setResponseMessage] = useState('');

  // Handle input changes for all fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new URLSearchParams();
    payload.append('firstName', formData.firstName);
    console.log("First Name:" ,formData.firstName);
    payload.append('lastName', formData.lastName);
    payload.append('email', formData.email);
    payload.append('message', formData.message);
    console.log('Payload:', payload.toString());

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbwx7Xj0IdS3qxX2cMIzuln-379qVFU6_WLvklUmoHXnrU4gTIglM1D97bXjXBU7XY9J/exec', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: payload.toString()
      });

      const text = await response.text();
      const result = JSON.parse(text);
      setResponseMessage(result.result || 'Message sent!');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        message: ''
      });
    } catch (error) {
      console.error('Submit error:', error);
      setResponseMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <div className="contact-container">
      <section className="image">
        <div className="image-container">
          <img src={contactUsImage} alt="Contact us" />
        </div>
      </section>

      <div className="contact-card-container">
        <div className="contact-card">
          <div className="contact-left">
            <h2>Contact Us</h2>
            <p><strong>We’d Love to Hear From You!</strong></p>
            <p>Have questions, feedback, or need support? Fill out the form below or email us — we’ll get back to you as soon as possible.</p>
          </div>

          <div className="contact-right">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <label className='Fname'>First Name</label>
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />

                <label className='Fname'>Last Name</label>
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />

                <label className='Email'>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />

                <label className='Help'>How can we help you?</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <button type="submit" className="submit-button">SUBMIT</button>
            </form>

            {responseMessage && <p className="response-message">{responseMessage}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
